<div>
    <m-message state="information">
        <m-i18n k="m-session-expired:message"></m-i18n>
    </m-message>
    <p>
        <m-i18n k="m-session-expired:directions-1"></m-i18n>
    </p>
    <p>
        <m-i18n k="m-session-expired:directions-2"></m-i18n>
    </p>
    <m-link mode="link"
            :url="url"
            :target="target"
            @click="onClick">
        {{backToLabel}}
    </m-link>
</div>
